// Matevara — inject right-side secondary nav links (Subscribe & Save, About, etc.)
// Data source: Shopify Navigation menu with handle "header-right".
// Server-rendered to <script type="application/json" id="fs-header-right-menu"> by layout/theme.liquid.
// If the JSON tag is missing (menu not yet created in admin), JS no-ops safely.
// Client-editable: Admin > Online Store > Navigation > "Header right" menu.
//
// First link gets .fs-nav-extra--highlight (designer treatment — gold).
// Add more items via admin; styling rules in assets/fs-overrides.css.
(function () {
  'use strict';

  function readMenu() {
    var node = document.getElementById('fs-header-right-menu');
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn('[fs-header-extras] header-right menu JSON parse error', e);
      return [];
    }
  }

  function inject() {
    var rightCol = document.querySelector('.shopify-section-group-header-group .header__column--right');
    if (!rightCol) return;
    if (rightCol.querySelector('.fs-nav-extra')) return; // already injected

    var links = readMenu();
    if (links.length === 0) return; // menu not configured in admin

    // Wrap the extras in an inline-flex group so they sit side-by-side at their
    // own width. The right column is display:contents, so loose links would
    // scatter/overlap on narrow-desktop (990–1024) — the wrapper keeps them a unit.
    var group = document.createElement('div');
    // Reuse Ella's action-cell class so the group is grid-placed + vertically
    // centered exactly like the account/cart icon cells (they sit correctly;
    // a bare div lands in the wrong implicit grid row and drops ~40px).
    group.className = 'fs-nav-extra-group header__column-action';
    links.forEach(function (l, idx) {
      var a = document.createElement('a');
      a.href = l.url || '/';
      a.className = 'fs-nav-extra' + (idx === 0 ? ' fs-nav-extra--highlight' : '');
      a.textContent = l.title || '';
      if (l.active) a.setAttribute('aria-current', 'page');
      group.appendChild(a);
    });
    rightCol.insertBefore(group, rightCol.firstChild);
  }

  // ── Mobile trust-bar ticker ──────────────────────────────────
  // On phones the trust bar scrolls as a seamless ticker. We duplicate the
  // group-blocks once so a CSS translateX(-50%) loop has no visible seam.
  // CSS gates everything behind .fs-ticker-on + (max-width:749px).
  function initTrustTicker() {
    var bar = document.querySelector('[id$="__trust_bar"] .utility-bar');
    if (!bar || bar.dataset.fsTicker === 'done') return;
    if (window.innerWidth > 749) return; // desktop = static row, no clone
    var items = Array.prototype.filter.call(bar.children, function (el) {
      return el.classList && el.classList.contains('group-block');
    });
    if (items.length < 2) return;
    items.forEach(function (el) {
      var clone = el.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      bar.appendChild(clone);
    });
    bar.classList.add('fs-ticker-on');
    // Mark the nearest .announcement-bar wrapper as the clip viewport (CSS fallback for :has).
    var clip = bar.closest('.announcement-bar') || bar.parentElement;
    if (clip) clip.classList.add('fs-ticker-clip');
    bar.dataset.fsTicker = 'done';
  }

  // ── Mobile drawer: extra nav links + "Take the Quiz" CTA ──────
  // Ella's mobile menu drawer renders the Main menu only. We append the
  // right-side links (Subscribe & Save, About) and a bottom CTA — both
  // editable via theme settings — without touching Ella core files.
  function readJSON(id, fallback) {
    var node = document.getElementById(id);
    if (!node) return fallback;
    try { return JSON.parse(node.textContent || 'null') || fallback; }
    catch (e) { return fallback; }
  }

  function enhanceDrawer() {
    var drawer = document.querySelector('#Drawer-Menu, .drawer--menu');
    if (!drawer) return;
    // Heading "Menu" → brand name (Figma 684:2389). Locale string left untouched
    // so cart/other drawers keep "Menu"; only the mobile menu drawer is renamed.
    var heading = drawer.querySelector('.drawer__heading');
    if (heading && heading.dataset.fsRenamed !== '1') {
      heading.textContent = 'Matevara';
      heading.classList.add('fs-drawer-heading');
      heading.dataset.fsRenamed = '1';
    }
    var list = drawer.querySelector('.menu-drawer__menu');
    if (list && !list.querySelector('.fs-drawer-extra')) {
      var links = readMenu(); // header-right items
      links.forEach(function (l, idx) {
        var li = document.createElement('li');
        li.className = 'menu-drawer__list-item fs-drawer-extra';
        var a = document.createElement('a');
        a.href = l.url || '/';
        a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset'
          + (idx === 0 ? ' fs-drawer-extra--highlight' : '');
        a.textContent = l.title || '';
        if (l.active) a.setAttribute('aria-current', 'page');
        li.appendChild(a);
        list.appendChild(li);
      });
    }
    // Bottom CTA
    var wrapper = drawer.querySelector('.menu-drawer, .drawer__wrapper');
    if (wrapper && !drawer.querySelector('.fs-drawer-cta')) {
      var cta = readJSON('fs-drawer-cta', null);
      if (cta && cta.label) {
        var foot = document.createElement('div');
        foot.className = 'fs-drawer-cta';
        var btn = document.createElement('a');
        btn.href = cta.url || '/';
        btn.className = 'fs-drawer-cta__btn';
        btn.textContent = cta.label;
        foot.appendChild(btn);
        (drawer.querySelector('.drawer__inner, .menu-drawer__navigation-container') || wrapper).appendChild(foot);
      }
    }
  }

  function initAll() { inject(); initTrustTicker(); enhanceDrawer(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  // Drawer may render lazily on first open — re-run when the burger is tapped.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu')) {
      setTimeout(enhanceDrawer, 50);
      setTimeout(enhanceDrawer, 400);
    }
  });
}());
